// extracted by mini-css-extract-plugin
export default {"draft-toolbar":"style_draft-toolbar__dljsk","draft-editor":"style_draft-editor__cp1Oc","draft-wrapper":"style_draft-wrapper__DG57d"};